/*
 *
 * PartnerPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'partnerPage';
export const initialState = {
    activities: {
        errorMessage: '',
        hasMore: false,
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: [],
    },
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    params: {
        id: '',
        slug: '',
    },
    recommends: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: [],
    },
    userImages: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
};

/* eslint-disable no-param-reassign, default-case */
function partnerPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            // Page
            case ActionTypes.RESET_PAGE:
                draft.page.res = initialState.page.res;
                return draft;
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Activities
            case ActionTypes.RESET_ACTIVITIES:
                draft.activities.res = initialState.activities.res;
                return draft;
            case ActionTypes.FETCH_ACTIVITIES_STARTED:
                draft.activities.isLoading = true;
                draft.activities.isError = false;
                draft.activities.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_ACTIVITIES_SUCCESSFULLY:
                draft.activities.isLoading = false;
                draft.activities.isLoaded = true;
                draft.activities.res = action.res;
                return draft;
            case ActionTypes.FETCH_ACTIVITIES_FAILED:
                draft.activities.isLoading = false;
                draft.activities.isError = true;
                draft.activities.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_ACTIVITIES_CANCELLED:
                draft.activities.isLoading = false;
                return draft;
            case ActionTypes.SET_ACTIVITIES_IS_LOADED:
                draft.activities.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.SET_ACTIVITIES_HAS_MORE:
                draft.activities.hasMore = action.hasMore;
                return draft;
            // Recommends
            case ActionTypes.FETCH_RECOMMENDS_STARTED:
                draft.recommends.isLoading = true;
                draft.recommends.isError = false;
                draft.recommends.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY:
                draft.recommends.isLoading = false;
                draft.recommends.isLoaded = true;
                draft.recommends.res = action.res;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_FAILED:
                draft.recommends.isLoading = false;
                draft.recommends.isError = true;
                draft.recommends.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_CANCELLED:
                draft.recommends.isLoading = false;
                return draft;
            case ActionTypes.SET_RECOMMENDS_IS_LOADED:
                draft.recommends.isLoaded = action.isLoaded;
                return draft;
            // userImages
            case ActionTypes.FETCH_USER_IMAGES_STARTED:
                draft.userImages.isLoading = true;
                draft.userImages.isError = false;
                draft.userImages.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY:
                draft.userImages.isLoading = false;
                draft.userImages.isLoaded = true;
                draft.userImages.res = { ...action.res, ...draft.userImages.res };
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_FAILED:
                draft.userImages.isLoading = false;
                draft.userImages.isError = true;
                draft.userImages.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_CANCELLED:
                draft.userImages.isLoading = false;
                return draft;
            case ActionTypes.SET_USER_IMAGES_IS_LOADED:
                draft.userImages.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default partnerPageReducer;
